import React, { PureComponent } from 'react'
import {
  Grid,
  TableRow,
  Table,
  TableHead,
  TableCell,
  Paper,
  Button,
  TableBody,
} from '@material-ui/core'
import PricingTemplateItem from '../../components/PricingTemplate/PricingTemplateItem'
import AddPricingTemplate from './AddPricingTemplate'
import ModalDialog from '../common/ModalDialog'
import { priceBreaksValues, Appcues } from '../../utils/constants'
import { hasAccess } from '../../utils/api'

export default class PricingTemplateContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      data: {},
    }
  }

  openAddPricingModal = () => {
    this.addPricingModal.handleClickOpen()
  }

  addPricingTier = () => {
    const { weightToleranceValues = [] } = this.props
    const priceRanges = weightToleranceValues
      .filter((tolerance) => tolerance.enabled)
      .map((tolerance) => {
        return { price: 0, weightToleranceId: tolerance.id, weightTolerance: { ...tolerance } }
      })
    /* const priceBreaks = priceBreaksValues.map(priceBreak => {
            return {price:0, priceBreakType: priceBreak.value, name: priceBreak.name}
        }) */

    this.props.getPriceBreaks('EACH').then((res) => {
      Appcues.track('Adding Pricing Tier')
      this.setState({
        data: {
          unitType: 'units',
          priceRanges,
          weightPerUnit: 'EACH',
          active: true,
          priceBreaks: res.priceBreaks,
        },
      })
      this.enableEdit()
      this.openAddPricingModal()
    })
  }

  onSave = (index) => (data, afterSave) => {}

  onSaveNew = (data, afterSave) => {}

  onDelete = (index) => () => {}

  enableEdit = () => {
    this.setState({
      editMode: true,
    })
  }

  disableEdit = () => {
    this.setState({
      editMode: false,
    })
  }

  onEdit =
    (index = 0) =>
    () => {
      Appcues.track('Updating Pricing Template')
      const { pricingTemplates = {} } = this.props
      const { values = [] } = pricingTemplates || {}

      const data = values[index]

      let { priceBreaks, priceRanges } = data

      if (!priceBreaks) {
        priceBreaks = priceBreaksValues.map((priceBreak) => {
          return { price: 0, priceBreakType: priceBreak.value, name: priceBreak.name }
        })
      } else if (!priceRanges) {
        const { weightToleranceValues = [] } = this.props
        priceRanges = weightToleranceValues
          .filter((tolerance) => tolerance.enabled)
          .map((tolerance) => {
            return { price: 0, weightToleranceId: tolerance.id, weightTolerance: { ...tolerance } }
          })
      }

      this.setState({
        data: {
          ...data,
          priceRanges,
          priceBreaks,
        },
      })
      this.enableEdit()
      this.openAddPricingModal()
    }

  onView =
    (index = 0) =>
    () => {
      Appcues.track('View Pricing template Info')
      const { pricingTemplates = {} } = this.props
      const { values = [] } = pricingTemplates || {}

      this.setState({
        data: values[index],
      })
      this.disableEdit()
      this.openAddPricingModal()
    }

  onChange = (key) => (event) => {
    const { value } = event.target

    if (key === 'unitType' && value === 'units') {
      const { weightPerUnit = 'EACH' } = this.state.data
      this.props.getPriceBreaks(weightPerUnit).then((res) => {
        this.setState((prevState) => {
          return {
            data: {
              ...prevState.data,
              [key]: value,
              priceBreaks: res.priceBreaks,
            },
          }
        })
      })
    } else if (key === 'weightPerUnit') {
      const weightPerUnit = value
      this.props.getPriceBreaks(weightPerUnit).then((res) => {
        this.setState((prevState) => {
          return {
            data: {
              ...prevState.data,
              [key]: value,
              priceBreaks: res.priceBreaks,
            },
          }
        })
      })
    } else {
      this.setState((prevState) => {
        return {
          data: {
            ...prevState.data,
            [key]: value,
          },
        }
      })
    }
  }

  onConfirm = () => {
    const { data } = this.state
    Appcues.track('Pricing Template Saved')
    this.props.onSavePricingTemplate(data, () => this.addPricingModal.handleClose())
  }

  onChangePricing =
    (key, index, childKey, isCheckBox = false) =>
    (event) => {
      const { data } = this.state
      const pricingList = data[key]
      let updatedPricingList = [...pricingList]
      updatedPricingList[index] = {
        ...updatedPricingList[index],
        [childKey]: isCheckBox ? event.target.checked : event.target.value,
      }

      this.setState((prevState) => {
        return {
          data: {
            ...prevState.data,
            [key]: updatedPricingList,
          },
        }
      })
    }

  onDelete = (index) => () => {
    Appcues.track('Deleting Price Template')
    const { pricingTemplates = {} } = this.props
    const { values = [] } = pricingTemplates || {}

    this.setState({
      data: values[index],
    })

    this.confirmDeletePricing.handleClickOpen()
  }

  onConfirmDelete = () => {
    Appcues.track('Pricing Template Deleted')
    const { data } = this.state
    this.props.onDelete(data, () => this.confirmDeletePricing.handleClose())
  }

  render() {
    const { editMode = false, data = {} } = this.state
    const { pricingTemplates = {}, weightToleranceValues = [] } = this.props
    const { values = [] } = pricingTemplates || {}
    const permitted = hasAccess()
    return (
      <Grid container className="paper-page">
        {hasAccess() ? (
          <Grid className="addButton" item lg={12}>
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={this.addPricingTier}
            >
              Add Pricing Tier
            </Button>
          </Grid>
        ) : (
          <Grid className="addButton" item lg={12}></Grid>
        )}
        <Grid className="unversalScroll" item lg={12}>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Unit of Measurement</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {values.map((template, index) => {
                  return (
                    <PricingTemplateItem
                      key={index}
                      index={index}
                      onEdit={this.onEdit(index)}
                      onView={this.onView(index)}
                      template={template}
                      onDelete={this.onDelete(index)}
                      permitted={permitted}
                    />
                  )
                })}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        <ModalDialog
          title={!editMode ? 'View Pricing' : `${!data.id ? 'Add' : 'Edit'} Pricing Template`}
          ref={(c) => (this.addPricingModal = c)}
          onConfirm={this.onConfirm}
          confirmText={'Save'}
          maxWidth="md"
          hideSave={!editMode}
          cancelText={editMode ? 'Cancel' : 'Close'}
          paperStyle={{ maxWidth: '100%', minWidth: '80%' }}
          //onClose={this.resetPassword}
        >
          <AddPricingTemplate
            editMode={editMode}
            data={data}
            onChange={this.onChange}
            weightToleranceValues={weightToleranceValues}
            onChangePricing={this.onChangePricing}
          />
        </ModalDialog>
        <ModalDialog
          title={`Delete Template ${data.name}`}
          ref={(c) => (this.confirmDeletePricing = c)}
          onConfirm={this.onConfirmDelete}
          confirmText={'Delete'}
          //onClose={this.resetPassword}
        >
          Are you sure you want to delete {data.name}?
        </ModalDialog>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PricingTemplate/PricingTemplateContainer.js